export default "__VITE_ASSET__B3xLO_yu__"